<template>
  <div class="h-100" v-loading.fullscreen.lock="loading">
    <div v-if="getError" class="link-error">
      <div class="inner">
        <div class="icon">
          <img src="../../assets/img/icons/link-expired.png" alt="" />
        </div>
        <h1>{{ getError }}</h1>
      </div>
    </div>
    <iframe
      :src="reportData.src"
      width="100%"
      :height="getScreenHeight"
      class="iframe-preview"
      v-else
    ></iframe>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
export default {
  mixins: [FileDownloadHelper],
  data() {
    return {
      loading: false,
      reportData: {
        src: "",
      },
    };
  },
  async mounted() {
    await this.onPdfView();
  },
  computed: {
    ...mapGetters("cases", ["getReportPreview"]),
    ...mapGetters("errors", ["getError"]),
    getScreenHeight() {
      return screen.height - 200;
    },
  },
  methods: {
    async onPdfView() {
      try {
        this.loading = true;
        this.$store.commit("errors/clear", null, { root: true });
        await this.$store.dispatch("cases/fetchReportPreview", {
          id: this.$route.params.report_id,
          caseId: this.$route.params.case_id,
        });
        this.reportData.src = this.getReportPreview?.download_url
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.link-error {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    position: relative;
    img {
      width: 150px;
      margin: 0 auto;
      display: table;
    }
  }
  h1 {
    margin-top: 0.5em;
    font-size: 1.4em;
    font-weight: 600;
    color: #3084ec;
    text-align: center;
  }
}
</style>
